// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// This file added to add style for the my list creat/edit modal to match the modal style with the general one
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TextFieldProps } from "@insite/mobius/TextField";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { MediaQuery } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

export interface MyListsEditListFormStyles {
    container?: GridContainerProps;
    nameGridItem?: GridItemProps;
    nameTextField?: TextFieldProps;
    descriptionGridItem?: GridItemProps;
    descriptionTextField?: TextFieldProps;
    buttonsGridItem?: GridItemProps;
    cancelButton?: ButtonPresentationProps;
    createButton?: ButtonPresentationProps;
    buttonsWrapper?: InjectableCss;
}

export const myListsEditListFormStyles: MyListsEditListFormStyles = {
    container: {
        css: css`
            div[class^="GridOffset"] {
                width: auto;
            }
        `,
    },
    nameGridItem: {
        width: 12,
    },
    descriptionGridItem: {
        width: 12,
    },
    buttonsGridItem: {
        width: 12,
    },
    buttonsWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            flex: 1;
            flex-direction: row-reverse;
            padding: 20px 40px;
            margin: 40px -40px -20px;
            background-color: ${getColor("common.ui3")};

            button:not(:last-child) {
                margin-left: 10px;
                margin-right: 0;
            }

            ${MediaQuery.lte("sm")} {
                flex-direction: column-reverse;

                button:not(:last-child) {
                    margin-left: 0;
                    margin-top: 10px;
                }
            }
        `,
    },
    cancelButton: {
        color: "secondary",
        css: css`
            margin-right: 10px;
        `,
    },
};
